import { render, staticRenderFns } from "./UserAccountLogo.vue?vue&type=template&id=98f053de&"
import script from "./UserAccountLogo.vue?vue&type=script&lang=ts&"
export * from "./UserAccountLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports